import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Observable } from "rxjs";
import { ExperienceStepModel } from "@models/experience-steps.model";
import { ExperienceStepsService } from "@services/experience/experience-steps.service";

@Component({
  selector: "app-steps",
  templateUrl: "./steps.component.html",
  styleUrls: ["./steps.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class StepsComponent implements OnInit {
  steps: Observable<ExperienceStepModel[]>;
  currentStep: Observable<ExperienceStepModel>;

  constructor(private stepsService: ExperienceStepsService) {}

  ngOnInit(): void {
    this.steps = this.stepsService.getSteps();
    this.currentStep = this.stepsService.getCurrentStep();
  }

  async onStepClick(step: ExperienceStepModel) {
    if (
      step.isComplete ||
      (step.stepIndex &&
        this.currentStep &&
        this.stepsService.isStepOpenedEarlier(step.stepIndex))
    ) {
      this.stepsService.setCurrentStep(step);
    }
  }
}
